import React from "react";
import { Link } from "react-router-dom";
import NavigationHeader from "../../components/ui/NavigationHeader";
import { useAuth } from "../../contexts/AuthContext";

export default function Privacy() {
  const { user, userProfile } = useAuth();
  const currentTier = userProfile?.subscription_tier || "free";

  return (
    <div className="min-h-screen min-h-[100dvh] bg-background">
      <NavigationHeader
        user={{ name: user?.email?.split("@")[0] || "Utilisateur" }}
        subscriptionTier={currentTier}
      />
      <main className="max-w-4xl mx-auto px-4 py-10">
        <div className="mb-8">
          <h1 className="text-3xl font-semibold text-foreground">Politique de confidentialité</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Dernière mise à jour : {new Date().toLocaleDateString("fr-CA")}
          </p>
        </div>

        <div className="prose prose-neutral max-w-none dark:prose-invert">
          <p>
            Cette politique explique comment <strong>ImmoIQ</strong> collecte, utilise et protège vos
            renseignements lorsque vous utilisez notre plateforme.
          </p>

          <h2>1. Données collectées</h2>
          <p>Nous pouvons collecter :</p>
          <ul>
            <li>
              <strong>Données de compte</strong> : courriel, identifiants, informations de profil.
            </li>
            <li>
              <strong>Données d’utilisation</strong> : pages visitées, événements, limites d’usage,
              logs techniques.
            </li>
            <li>
              <strong>Données d’analyse</strong> : informations immobilières que vous saisissez ou
              importez (revenus, dépenses, loyers, etc.).
            </li>
            <li>
              <strong>Paiement</strong> : la facturation est gérée par un processeur de paiement
              externe (ex. Stripe). Nous ne stockons généralement pas les numéros de carte.
            </li>
          </ul>

          <h2>2. Utilisation des données</h2>
          <ul>
            <li>fournir et améliorer le Service;</li>
            <li>sécuriser la plateforme et prévenir les abus;</li>
            <li>support client et communications de service;</li>
            <li>mesurer l’utilisation et améliorer l’expérience.</li>
          </ul>

          <h2>3. IA et traitement de contenu</h2>
          <p>
            Certaines fonctionnalités peuvent envoyer du contenu (ex. texte extrait d’une page web ou
            données saisies) à des services d’IA pour produire une extraction/réponse. Nous cherchons
            à limiter les données envoyées au strict nécessaire.
          </p>

          <h2>4. Partage avec des tiers</h2>
          <p>
            Nous pouvons partager certaines données avec des fournisseurs nécessaires au Service :
          </p>
          <ul>
            <li>hébergement / base de données (ex. Supabase);</li>
            <li>paiements (ex. Stripe);</li>
            <li>analytique / logs (si activés);</li>
            <li>fournisseurs IA (si fonctionnalités IA utilisées).</li>
          </ul>
          <p>
            Nous ne vendons pas vos renseignements personnels.
          </p>

          <h2>5. Cookies</h2>
          <p>
            Nous pouvons utiliser des cookies/stockage local pour la session, les préférences (ex.
            thème) et la sécurité. Vous pouvez limiter les cookies dans votre navigateur, mais
            certaines fonctions pourraient ne plus fonctionner.
          </p>

          <h2>6. Conservation</h2>
          <p>
            Nous conservons vos données aussi longtemps que nécessaire pour fournir le Service, gérer
            la conformité et résoudre des litiges. Vous pouvez demander la suppression de votre compte
            (sous réserve d’obligations légales).
          </p>

          <h2>7. Sécurité</h2>
          <p>
            Nous utilisons des mesures de sécurité raisonnables (contrôles d’accès, chiffrement en
            transit, etc.). Aucun système n’est toutefois garanti à 100%.
          </p>

          <h2>8. Vos droits</h2>
          <p>
            Selon votre juridiction, vous pouvez demander l’accès, la correction ou la suppression de
            vos renseignements. Contactez-nous pour une demande.
          </p>

          <h2>9. Contact</h2>
          <p>
            Pour toute question : <Link className="underline" to="/contact">nous contacter</Link>.
          </p>
        </div>
      </main>
    </div>
  );
}
